import { Instagram, MessageCircle, FolderSearch, MessageSquareOff, UserX, Compass } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const PROBLEMS = [
    {
        icon: Instagram,
        title: "Instagram desorganizado",
        text: "O perfil existe, mas não comunica claramente o que a empresa oferece.",
    },
    {
        icon: MessageCircle,
        title: "WhatsApp sem estrutura",
        text: "O cliente chega, mas encontra uma comunicação improvisada.",
    },
    {
        icon: FolderSearch,
        title: "Informações espalhadas",
        text: "O cliente precisa procurar demais para entender o negócio.",
    },
    {
        icon: MessageSquareOff,
        title: "Comunicação pouco profissional",
        text: "A imagem digital não transmite a qualidade real da empresa.",
    },
    {
        icon: UserX,
        title: "Seguidores que não viram clientes",
        text: "Existe presença, mas falta uma estrutura comercial por trás dela.",
    },
    {
        icon: Compass,
        title: "Falta de estratégia",
        text: "Cada canal funciona de uma maneira e o cliente não encontra uma jornada clara.",
    },
];

const Problem = () => (
    <section data-testid="problem-section" className="relative py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeading
                eyebrow="O problema"
                title={
                    <>
                        Seu cliente já está procurando por você.
                        <br />
                        <span className="text-ink3">A questão é: o que ele encontra?</span>
                    </>
                }
            />

            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {PROBLEMS.map((p, i) => (
                    <Reveal key={p.title} delay={0.06 * i} className="h-full">
                        <article
                            data-testid={`problem-card-${i + 1}`}
                            className="card-hover h-full rounded-2xl border border-line bg-card p-7 flex flex-col gap-5"
                        >
                            <div className="flex items-center justify-between">
                                <div className="w-11 h-11 rounded-xl border border-line bg-bg2 flex items-center justify-center text-ink2">
                                    <p.icon size={19} strokeWidth={1.6} />
                                </div>
                                <span className="font-mono2 text-xs text-gold/60">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                            </div>
                            <h3 className="font-display text-lg font-semibold text-ink leading-snug">
                                {p.title}
                            </h3>
                            <p className="text-sm sm:text-[15px] text-ink2 leading-relaxed">{p.text}</p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Problem;
